<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasLogIntegPerm.value" :to="{name: 'moodle-undb-pos-logs-integracoes', query: {instancia: '(undbpos)'} }">Log Integrações</v-btn>
            <v-btn v-if="hasResetPassPerm.value" :to="{name: 'moodle-undb-pos-reset-password'}">Redefinição de Senha</v-btn>
            <v-btn v-if="hasLogResetPassPerm.value" :to="{name: 'moodle-undb-pos-log-reset-password', query: {instancia: '(undbpos)'}}">Logs de Redefinição de Senhas</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasLogIntegPerm = ref(false)
const hasResetPassPerm = ref(false)
const hasLogResetPassPerm = ref(false)
const router = useRouter();
hasLogIntegPerm.value = computed(() => router.resolve({name: 'moodle-undb-pos-logs-integracoes'}).meta.has_perm())
hasResetPassPerm.value = computed(() => router.resolve({name: 'moodle-undb-pos-reset-password'}).meta.has_perm())
hasLogResetPassPerm.value = computed(() => router.resolve({name: 'moodle-undb-pos-log-reset-password'}).meta.has_perm())
</script>